import css from "./Dashboard.sass?inline"
import {Lifecycle} from "@opendaw/lib-std"
import {createElement} from "@opendaw/lib-jsx"
import {StudioService} from "@/service/StudioService.ts"
import {Html} from "@opendaw/lib-dom"
import {addFlashlightEffect} from "@/ui/pages/FlashlightEffect"
import {Resources} from "@/ui/dashboard/Resources"
import {DemoProjects} from "@/ui/dashboard/DemoProjects"
import {TextToSongWidget} from "@/ui/dashboard/TextToSongWidget"

const className = Html.adoptStyleSheet(css, "Dashboard")

type Construct = {
    lifecycle: Lifecycle
    service: StudioService
}

export const Dashboard = ({lifecycle, service}: Construct) => {
    const root = (
        <div className={className}>
            <article>
                <div className="hero">
                    <h1>What music will you <span className="accent">create</span> today?</h1>
                    <h2>Create stunning music by describing it with text.</h2>
                </div>
                <TextToSongWidget service={service}/>
                <div className="columns">
                    <DemoProjects lifecycle={lifecycle} service={service}/>
                    <Resources lifecycle={lifecycle} service={service}/>
                </div>
            </article>
        </div>
    ) as unknown as HTMLDivElement
    addFlashlightEffect(root)
    return root
}
